import { API_ROOT } from "../../constants/constants";
import { getAccessToken } from "../../utils/okta-config";

export async function allOrdersData(supplierId) {
  try {
    let url = `${process.env.REACT_APP_API_ENDPOINT}/forwarder/allOrder/getAllOrders/${supplierId}`;
    const requestOptions = {
      method: "GET",
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        "Access-Control-Allow-Origin": API_ROOT,
    },
    };
    const response = await fetch(url, requestOptions);
    if (!response.ok) {
      throw new Error(`Error! status: ${response.status}`);
    }
    const result = await response.json();
    // console.log(result);
    if (result) {
      for (let i = 0; i < result.body.content[0].length; i++) {
        if (result.body.content[0][i].dateShipped != null) {
          let shippedDate = result.body.content[0][i].dateShipped.substr(0, 10);
          result.body.content[0][i].dateShipped = shippedDate;
        }
      }
    }
    // console.log(result)
    return result;
  } catch (error) {
    console.log(error);
  }
}
